import { AppLayoutContainer } from '@zg-rentals/zrm-header-navigation';
import Link from 'next/link';
import { Auth, useAuth } from '@/AuthProvider';
import { Box, Spinner } from '@zillow/constellation-10';
import { zillowLoginRedirectHref } from '@zg-rentals/login-zillow/client';

const host = typeof window !== 'undefined' && window !== null ? window.location.host : 'www.zillow.com';

const ZRAMPageLayoutSkeleton = () => (
  <Box
    css={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
    }}
  >
    <Spinner size="lg" />
  </Box>
);

const ZRAMPageLayoutContent = ({ children, isFullScreen }: { children: React.ReactNode; isFullScreen?: boolean }) => {
  const pathname = typeof window !== 'undefined' && window !== null ? window.location.href : '';
  const { user } = useAuth();

  if (!user) return null;

  return (
    <AppLayoutContainer
      host={host}
      pathname={pathname}
      brand="zillow"
      userModel={user}
      altLogo={true}
      reactRouterLink={Link}
      hideNavigation={isFullScreen}
      hideFooter={isFullScreen}
    >
      {children}
    </AppLayoutContainer>
  );
};

const zillowLoginRedirect = zillowLoginRedirectHref({
  baseURL: process.env.NEXT_PUBLIC_AUTH_BASE_URL,
  entryPoint: 'zram-ad-management-web',
  forwardPrefix: process.env.NEXT_PUBLIC_AUTH_FORWARD_PREFIX,
  forceLogin: true,
});

export const ZRAMPageLayout = ({ children, isFullScreen }: { children: React.ReactNode; isFullScreen?: boolean }) => (
  <Auth.Boundary redirectHref={zillowLoginRedirect} loading={<ZRAMPageLayoutSkeleton />}>
    <ZRAMPageLayoutContent isFullScreen={isFullScreen}>{children}</ZRAMPageLayoutContent>
  </Auth.Boundary>
);
